module.exports = __webpack_public_path__ + "img/logo.603c31f0.svg";